import { slotList } from "@/Util/manifest";


var dataConfigItems=require.context(".", true, /.+\.js$/);

var dataForms={};
for(let key of dataConfigItems.keys()) {
  if (key.indexOf("dataForms")!=-1)
    continue;
  var item=dataConfigItems(key).default;
  dataForms={...dataForms, ...item};
}



export { dataForms };
